/**
 * Standalone STM32 Embedded C Suite page
 * Dedicated route at /open-source/stm32-embedded-c-suite
 * Wraps STM32SuitePage with full SEO metadata and JSON-LD schema
 * for crawlability (the main /open-source page hides it behind a tab).
 */

import React from 'react';
import SEO from '../../../../components/SEO';
import STM32SuitePage from './STM32SuitePage';

const stm32Schema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "STM32 Embedded C Code Suite",
  "applicationCategory": "DeveloperApplication",
  "operatingSystem": "Bare-metal / FreeRTOS",
  "description":
    "Free, open-source STM32 embedded C library that builds out of the box on every ARM Cortex-M core (M0 through M33) with a generated GNU startup, linker script, and CMake project. Includes bare-metal GPIO and I2C drivers, an independent watchdog and a fault-recovery handler, SPI, and UART/Timer/ADC on STM32F0/F1/F4/F7/G0/L4, plus 8 sensor and display modules (BME280, MPU6050, SSD1306, DHT22, and more) and optional FreeRTOS. Every register map is verified against ST's official CMSIS device headers. Select your MCU, pick what you need, and download a ready-to-build project. Compile-verified across all 18 families; on-device validation is ongoing.",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR"
  },
  "author": {
    "@type": "Organization",
    "name": "Riviera Tech Solutions",
    "url": "https://rivieratech.solutions"
  },
  "keywords": [
    "STM32 drivers",
    "embedded C library",
    "STM32 GPIO driver",
    "STM32 UART driver",
    "STM32 SPI driver",
    "STM32 I2C driver",
    "STM32 ADC driver",
    "STM32 timer driver",
    "FreeRTOS STM32",
    "STM32F4 drivers",
    "STM32H7 drivers",
    "STM32 HAL alternative",
    "bare-metal STM32",
    "STM32 CMake project",
    "embedded systems",
    "electronics engineering",
    "microcontroller programming"
  ]
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://rivieratech.solutions/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Open Source",
      "item": "https://rivieratech.solutions/open-source"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "STM32 Embedded C Suite",
      "item": "https://rivieratech.solutions/open-source/stm32-embedded-c-suite"
    }
  ]
};

const combinedSchema = [stm32Schema, breadcrumbSchema];

export default function STM32SuiteStandalone() {
  return (
    <>
      <SEO
        title="Free STM32 Embedded C Drivers – GPIO, UART, SPI, I2C, FreeRTOS & More"
        description="Free open-source STM32 embedded C library. Builds out of the box on every Cortex-M core (M0–M33) with generated GNU startup, linker and CMake. GPIO, I2C, watchdog, fault recovery, SPI; UART/Timer/ADC on F0/F1/F4/F7/G0/L4; register maps CMSIS-verified; 8 sensor modules; optional FreeRTOS. No sign-up."
        keywords="STM32 drivers, embedded C library, STM32 GPIO, STM32 UART, STM32 SPI, STM32 I2C, STM32 ADC, STM32 timer, FreeRTOS STM32, STM32F4 drivers, STM32 HAL alternative, bare metal STM32, STM32 CMake project, arm-none-eabi-gcc, STM32 watchdog IWDG, embedded systems, microcontroller programming, electronics engineering, STM32F103, STM32F407, STM32 code generator, embedded firmware, ARM Cortex-M, STM32 peripheral drivers, STM32 OLED SSD1306, STM32 DHT22, STM32 BME280, STM32 MPU6050"
        url="/open-source/stm32-embedded-c-suite"
        schema={combinedSchema}
      />
      <div className="pt-20">
        <STM32SuitePage />
      </div>
    </>
  );
}
